module.exports = __webpack_public_path__ + "img/icon-vot-addcontestant.475dff74.png";